import { FallbackIcon } from '../../shared';
import { AccentIconName } from './AccentIconName';
import IconAdminFee from './IconAdminFee';
import IconAmountBilled from './IconAmountBilled';
import IconAmountReceived from './IconAmountReceived';
import IconApiDocs from './IconApiDocs';
import IconBellFilled from './IconBellFilled';
import IconCalendar from './IconCalendar';
import IconCampaignApproved from './IconCampaignApproved';
import IconCampaignCancelled from './IconCampaignCancelled';
import IconCampaignWaiting from './IconCampaignWaiting';
import IconCheckmark from './IconCheckmark';
import IconCircleAccount from './IconCircleAccount';
import IconCircleAccountGrey from './IconCircleAccountGrey';
import IconCircleTime from './IconCircleTime';
import IconDone from './IconDone';
import IconExcel from './IconExcel';
import IconExclamation from './IconExclamation';
import IconFile from './IconFile';
import IconFlagEn from './IconFlagEn';
import IconFlagId from './IconFlagId';
import IconIdCard from './IconIdCard';
import IconLineDashed from './IconLineDashed';
import IconLoader from './IconLoader';
import IconMasterCard from './IconMasterCard';
import IconMoneyGreen from './IconMoneyGreen';
import IconMoneyRed from './IconMoneyRed';
import IconPaymentCheckoutLink from './IconPaymentCheckoutLink';
import IconPaymentInProgress from './IconPaymentInProgress';
import IconPdf from './IconPdf';
import IconProductBulkDisbursement from './IconProductBulkDisbursement';
import IconProductDocs from './IconProductDocs';
import IconRedDot from './IconRedDot';
import IconRedExclamation from './IconRedExclamation';
import IconRememberDevice from './IconRememberDevice';
import IconSearch from './IconSearch';
import IconSelfieWithIdCard from './IconSelfieWithIdCard';
import IconSlack from './IconSlack';
import IconSort from './IconSort';
import IconStarFilled from './IconStarFilled';
import IconStatusFailed from './IconStatusFailed';
import IconStatusInitiated from './IconStatusInitiated';
import IconStatusSuccess from './IconStatusSuccess';
import IconStatusWaiting from './IconStatusWaiting';
import IconStep1 from './IconStep1';
import IconStep2 from './IconStep2';
import IconStep3 from './IconStep3';
import IconStep4 from './IconStep4';
import IconTeams from './IconTeams';
import IconTelegram from './IconTelegram';
import IconTransactionReport from './IconTransactionReport';
import IconVisa from './IconVisa';
import IconWaiting from './IconWaiting';
import IconWhatsapp from './IconWhatsapp';
import IconWhatsapp2 from './IconWhatsapp2';
import IconXMark from './IconXMark';

/*
 * IMPORTANT!!
 * If you want to add icons,
 * you should insert it alphabetically either in import or in code bellow
 */
export const RenderAccentIcon = (name: AccentIconName): typeof IconVisa => {
  switch (name) {
    case 'admin-fee':
      return IconAdminFee;
    case 'amount-billed':
      return IconAmountBilled;
    case 'amount-received':
      return IconAmountReceived;
    case 'api-docs':
      return IconApiDocs;
    case 'bell-filled':
      return IconBellFilled;
    case 'calendar':
      return IconCalendar;
    case 'campaign-approved':
      return IconCampaignApproved;
    case 'campaign-cancelled':
      return IconCampaignCancelled;
    case 'campaign-waiting':
      return IconCampaignWaiting;
    case 'checkmark':
      return IconCheckmark;
    case 'circle-account':
      return IconCircleAccount;
    case 'circle-account-grey':
      return IconCircleAccountGrey;
    case 'circle-time':
      return IconCircleTime;
    case 'exclamation':
      return IconExclamation;
    case 'excel':
      return IconExcel;
    case 'file':
      return IconFile;
    case 'flag-en':
      return IconFlagEn;
    case 'flag-id':
      return IconFlagId;
    case 'id-card':
      return IconIdCard;
    case 'icon-done':
      return IconDone;
    case 'line-dashed':
      return IconLineDashed;
    case 'mastercard':
      return IconMasterCard;
    case 'money-green':
      return IconMoneyGreen;
    case 'money-red':
      return IconMoneyRed;
    case 'payment-in-progress':
      return IconPaymentInProgress;
    case 'pdf':
      return IconPdf;
    case 'product-bulk-disbursement':
      return IconProductBulkDisbursement;
    case 'product-docs':
      return IconProductDocs;
    case 'product-payment-checkout-link':
      return IconPaymentCheckoutLink;
    case 'red-exclamation':
      return IconRedExclamation;
    case 'remember-device':
      return IconRememberDevice;
    case 'search':
      return IconSearch;
    case 'selfie-with-id-card':
      return IconSelfieWithIdCard;
    case 'star-filled':
      return IconStarFilled;
    case 'sort':
      return IconSort;
    case 'status-failed':
      return IconStatusFailed;
    case 'status-initiated':
      return IconStatusInitiated;
    case 'status-success':
      return IconStatusSuccess;
    case 'status-waiting':
      return IconStatusWaiting;
    case 'step-1':
      return IconStep1;
    case 'step-2':
      return IconStep2;
    case 'step-3':
      return IconStep3;
    case 'step-4':
      return IconStep4;
    case 'transaction-report':
      return IconTransactionReport;
    case 'visa':
      return IconVisa;
    case 'waiting':
      return IconWaiting;
    case 'whatsapp':
      return IconWhatsapp;
    case 'whatsapp-2':
      return IconWhatsapp2;
    case 'xmark':
      return IconXMark;
    case 'loader':
      return IconLoader;
    case 'telegram':
      return IconTelegram;
    case 'slack':
      return IconSlack;
    case 'teams':
      return IconTeams;
    case 'red-dot':
      return IconRedDot;
    default:
      return FallbackIcon;
  }
};
